import { render, staticRenderFns } from "./FormHeadCreate.vue?vue&type=template&id=f5497bf2&scoped=true"
import script from "./FormHeadCreate.vue?vue&type=script&lang=js"
export * from "./FormHeadCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5497bf2",
  null
  
)

export default component.exports